import { action, computed, makeObservable, observable } from 'mobx';
import { Task } from '@bringg/types';

class SelectedTasksStore {
	_selectedTasks: Map<number, Task> = new Map();

	constructor() {
		makeObservable(this, {
			_selectedTasks: observable,
			clearSelectedTasks: action,
			setSelectedTasks: action,
			selectMany: action,
			selectedTasks: computed,
			total: computed
		});
	}

	setSelectedTasks = (selectedTask: Task, isCtrlClick: boolean) => {
		if (!selectedTask?.id) {
			return;
		}
		const updateState = new Map(this._selectedTasks);

		if (isCtrlClick) {
			if (updateState.has(selectedTask.id)) {
				updateState.delete(selectedTask.id);
			} else {
				updateState.set(selectedTask.id, selectedTask);
			}
		} else {
			if (updateState.size === 1 && updateState.has(selectedTask.id)) {
				updateState.delete(selectedTask.id);
			} else {
				updateState.clear();
				updateState.set(selectedTask.id, selectedTask);
			}
		}

		this._selectedTasks = updateState;
	};

	clearSelectedTasks = () => {
		this._selectedTasks = new Map();
	};

	get selectedTasks(): Task[] {
		return Array.from(this._selectedTasks.values());
	}

	get total(): number {
		return this._selectedTasks.size;
	}

	isTaskSelected = (taskId: number) => {
		return this._selectedTasks.has(taskId);
	};

	selectMany = (tasks: Task[], shouldSelect: boolean) => {
		const updateState = new Map(this._selectedTasks);
		tasks.forEach(task => {
			if (!task.id) {
				return;
			}
			if (shouldSelect) {
				updateState.set(task.id, task);
			} else {
				updateState.delete(task.id);
			}
		});
		this._selectedTasks = updateState;
	};
}

export default SelectedTasksStore;
